export const IocKey = {
  factory: Symbol.for('instance.factory'),

  adjustment: {
    repository: {
      adjustment: Symbol.for('adjustment.repository.adjustment'),
      adjustmentRemarksActivity: Symbol.for('adjustment.repository.adjustmentRemarksActivity'),
    },
    service: {
      createAndAdjust: Symbol.for('adjustment.service.createAndAdjust'),
      stateTransition: Symbol.for('adjustment.service.stateTransition'),
    },
    action: {
      fulfillAdjustment: Symbol.for('adjustment.action.fulfillAdjustment'),
    },
  },

  autonumber: {
    service: {
      autonumber: Symbol.for('autonumber.service.autonumber'),
    },
  },

  auth: {
    service: {
      passwordlessDeliveryFactory: Symbol.for('auth.service.passwordlessDeliveryFactory'),
      passwordlessSmsDelivery: Symbol.for('auth.service.passwordlessSmsDelivery'),
      passwordlessEmailDelivery: Symbol.for('auth.service.passwordlessEmailDelivery'),
    },
  },

  appSetting: {
    repository: {
      appSetting: Symbol.for('appSetting.repository.appSetting'),
    },
    service: {
      appSetting: Symbol.for('appSetting.service.appSetting'),
    },
  },

  board: {
    repository: {
      board: Symbol.for('board.repository.board'),
    },
  },
  blog: {
    repository: {
      blog: Symbol.for('blog.repository.blog'),
    },
    service: {
      blog: Symbol.for('blog.service.blog'),
    },
  },
  cache: {
    service: {
      cache: Symbol.for('cache.service.cache'),
    },
  },
  company: {
    repository: {
      company: Symbol.for('company.repository.company'),
      companyAddresses: Symbol.for('company.repository.companyAddresses'),
    },
    service: {
      updateRelatedToCompany: Symbol.for('company.service.updateRelatedToCompany'),
      createCompanyIfNotExists: Symbol.for('company.service.createCompanyIfNotExists'),
    },
  },
  customer: {
    repository: {
      customer: Symbol.for('customer.repository.customer'),
      customerAddresses: Symbol.for('customer.repository.customerAddresses'),
    },
    service: {
      manageCustomerOrCompanyAddress: Symbol.for('customer.service.manageCustomerOrCompanyAddress'),
      additionalCustomerFiltersAndInputs: Symbol.for('customer.service.additionalCustomerFiltersAndInputs'),
      getBasicCustomerInfo: Symbol.for('customer.service.getBasicCustomerInfo'),
      updateRelatedToCustomer: Symbol.for('customer.service.updateRelatedToCustomer'),
    },
  },
  chat: {
    gateway: {
      chat: Symbol.for('chat.gateway.chat'),
    },
    repository: {
      chat: Symbol.for('chat.repository.chat'),
      message: Symbol.for('chat.repository.message'),
    },
    service: {
      refreshChatMessages: Symbol.for('chat.service.refreshChatMessages'),
      userCache: Symbol.for('chat.service.userCache'),
      addCollaborators: Symbol.for('chat.service.addCollaborators'),
      addChatMessage: Symbol.for('chat.service.addChatMessage'),
    },
  },
  cron: {
    service: {
      cron: Symbol.for('cron.service.cron'),
    },
  },
  dbBackup: {
    service: {
      dbBackup: Symbol.for('dbBackup.service.dbBackup'),
    },
  },
  documentLock: {
    repository: {
      documentLock: Symbol.for('documentLock.repository.documentLock'),
    },
    service: {
      documentLock: Symbol.for('documentLock.service.documentLock'),
    },
  },
  history: {
    repository: {
      history: Symbol.for('history.repository.history'),
    },
    service: {
      history: Symbol.for('history.service.history'),
    },
  },
  inventoryTimeSeries: {
    repository: {
      inventoryTimeSeries: Symbol.for('inventoryTimeSeries.repository.inventoryTimeSeries'),
    },
    service: {
      inventoryTimeSeries: Symbol.for('inventoryTimeSeries.service.inventoryTimeSeries'),
    },
  },
  inventoryBySerialNumber: {
    repository: {
      inventoryBySerialNumber: Symbol.for('inventoryBySerialNumber.repository.inventoryBySerialNumber'),
    },
    service: {
      generateSerialNumber: Symbol.for('inventoryBySerialNumber.service.generateSerialNumber'),
      addMultipleSerialNumbers: Symbol.for('inventoryBySerialNumber.service.addMultipleSerialNumbers'),
      updateProductInventoryWithSerialNumbers: Symbol.for(
        'inventoryBySerialNumber.service.updateProductInventoryWithSerialNumbers'
      ),
      validateSerialNumber: Symbol.for('inventoryBySerialNumber.validator.validateSerialNumber'),
    },
  },
  log: {
    service: {
      log: Symbol.for('log.service.log'),
    },
    mongodbConnection: Symbol.for('log.mongodbConnection'),
  },
  logistic: {
    service: {
      stateTransition: Symbol.for('logistic.service.stateTransition'),
    },
    repository: {
      logistic: Symbol.for('logistic.repository.logistic'),
      logisticItem: Symbol.for('logistic.repository.logisticItem'),
      logisticRelatedLogistic: Symbol.for('logistic.repository.logisticRelatedLogistic'),
      logisticRemarksActivity: Symbol.for('logistic.repository.logisticRemarksActivity'),
    },
  },
  mail: {
    service: {
      mail: Symbol.for('mail.service.mail'),
    },
  },
  mailgunEvent: {
    repository: {
      mailgunEvent: Symbol.for('mailgunEvent.repository.mailgunEvent'),
    },
  },
  notification: {
    repository: {
      notification: Symbol.for('notification.repository.notification'),
    },
  },
  order: {
    repository: {
      order: Symbol.for('order.repository.order'),
      orderItem: Symbol.for('order.repository.orderItem'),
      orderAsset: Symbol.for('order.repository.orderAsset'),
      orderRemarksActivity: Symbol.for('order.repository.orderRemarksActivity'),
    },
    service: {
      stateTransition: Symbol.for('order.service.stateTransition'),
      order: Symbol.for('order.service.order'),
      getOrderedProducts: Symbol.for('order.service.getOrderedProducts'),
      fulfillOrder: Symbol.for('order.service.fulfillOrder'),
      capturePayment: Symbol.for('order.service.capturePayment'),
      notifyOrder: Symbol.for('order.service.notifyOrder'),
      setShippingRate: Symbol.for('order.service.setShippingRate'),
      updateInventoryBySerialNumberStatus: Symbol.for('order.service.updateInventoryBySerialNumberStatus'),
      extractOrderAddresses: Symbol.for('order.service.extractOrderAddresses'),
    },
  },

  product: {
    repository: {
      product: Symbol.for('product.repository.product'),
      productVendors: Symbol.for('product.repository.productVendors'),
      productBillOfMaterials: Symbol.for('product.repository.productBillOfMaterials'),
      productOperations: Symbol.for('product.repository.productOperations'),
      relatedProducts: Symbol.for('product.repository.relatedProducts'),
      productRemarksActivity: Symbol.for('product.repository.productRemarksActivity'),
    },
    service: {
      hasReferenceToOtherEntity: Symbol.for('product.service.hasReferenceToOtherEntity'),
      adjustMultipleProductInventory: Symbol.for('product.service.adjustMultipleProductInventory'),
      getProductComputedQuantityOnHand: Symbol.for('product.service.getProductComputedQuantityOnHand'),
      adjustProductQty: Symbol.for('product.service.adjustProductQty'),
      productBuild: Symbol.for('product.service.productBuild'),
      productDestruct: Symbol.for('product.service.productDestruct'),
      getProductsWithBillingMaterials: Symbol.for('product.service.getProductsWithBillingMaterials'),
      hasSubComponents: Symbol.for('product.service.hasSubComponents'),
    },
  },
  project: {
    repository: {
      project: Symbol.for('project.repository.project'),
      projectRemarksActivity: Symbol.for('project.repository.projectRemarksActivity'),
      projectRelatedWorkOrders: Symbol.for('project.repository.projectRelatedWorkOrders'),
    },
    service: {
      addProjectTasks: Symbol.for('project.service.addProjectTasks'),
      createProjectAndTasks: Symbol.for('project.service.createProjectAndTasks'),
      computeTotalTimeSpent: Symbol.for('project.service.computeTotalTimeSpent'),
      computeProjectTaskProgress: Symbol.for('project.service.computeProjectTaskProgress'),
      updateStatusByTasks: Symbol.for('project.service.updateStatusByTasks'),

      cloneProjectTask: Symbol.for('project.service.cloneProjectTask'),
    },
  },
  purchaseOrder: {
    service: {
      stateTransition: Symbol.for('purchaseOrder.service.stateTransition'),
    },
    repository: {
      purchaseOrder: Symbol.for('purchaseOrder.repository.purchaseOrder'),
      purchaseOrderItem: Symbol.for('purchaseOrder.repository.purchaseOrderItem'),
      purchaseOrderRemarksActivity: Symbol.for('purchaseOrder.repository.purchaseOrderRemarksActivity'),
    },
  },
  payment: {
    gateway: {
      payment: Symbol.for('payment.gateway.payment'),
    },
    service: {
      refundPayment: Symbol.for('payment.service.refundPayment'),
      createAchPayment: Symbol.for('payment.service.createAchPayment'),
      getPaymentMetadata: Symbol.for('payment.service.getPaymentMetadata'),
      captureCardPayment: Symbol.for('payment.service.captureCardPayment'),
      cancelUncapturedPayment: Symbol.for('payment.service.cancelUncapturedPayment'),
    },
  },
  queue: {
    service: {
      queue: Symbol.for('queue.service.queue'),
    },
  },
  qbo: {
    service: {
      qbo: Symbol.for('qbo.service.qbo'),
      createQuickbooksInvoice: Symbol.for('qbo.service.createQuickbooksInvoice'),
      itemMapping: Symbol.for('qbo.service.itemMapping'),
      customerMapping: Symbol.for('qbo.service.customerMapping'),
      quickbooksInvoice: Symbol.for('qbo.service.quickbooksInvoice'),
    },
  },
  shipping: {
    repository: {
      shipEngine: Symbol.for('shipping.repository.shipEngine'),
    },
    service: {
      cancelShipping: Symbol.for('shipping.service.cancelShipping'),
      createShipping: Symbol.for('shipping.service.createShipping'),
      getShippingRate: Symbol.for('shipping.service.getShippingRate'),
      estimateShippingFee: Symbol.for('shipping.service.estimateShippingFee'),
    },
    gateway: {
      shipping: Symbol.for('shipping.gateway.shipping'),
    },
  },
  sms: {
    service: {
      sms: Symbol.for('sms.sms'),
      simPortManager: Symbol.for('sms.service.simPortManager'),
    },
    gateway: {
      sms: Symbol.for('sms.gateway.sms'),
    },
  },
  task: {
    repository: {
      task: Symbol.for('task.repository.task'),
      taskRemarksActivity: Symbol.for('task.repository.taskRemarksActivity'),
    },
    service: {
      getSortedTasks: Symbol.for('task.service.getSortedTasks'),
      addTaskSubTasks: Symbol.for('task.service.addTaskSubTasks'),
      deleteTaskSubTasks: Symbol.for('task.service.deleteTaskSubTasks'),
      sortTaskSubTasks: Symbol.for('task.service.sortTaskSubTasks'),
    },
  },
  tenant: {
    repository: {
      tenant: Symbol.for('tenant.repository.tenant'),
    },
    service: {
      tenant: Symbol.for('tenant.service.tenant'),
    },
  },
  template: {
    repository: {
      template: Symbol.for('template.repository.template'),
    },
  },
  file: {
    repository: {
      file: Symbol.for('file.repository.file'),
      storage: Symbol.for('file.repository.storage'),
    },
    service: {
      file: Symbol.for('file.service.file'),
    },
  },
  pubsub: {
    service: {
      pubsub: Symbol.for('pubsub.service.pubsub'),
    },
  },

  s3: {
    service: {
      s3: Symbol.for('s3.service.s3'),
    },
  },

  stripe: {
    service: {
      processStripeEvents: Symbol.for('stripe.service.processStripeEvents'),
    },
  },

  user: {
    repository: {
      user: Symbol.for('user.repository.user'),
      userAddresses: Symbol.for('user.repository.userAddresses'),
    },
    service: {
      user: Symbol.for('user.service.user'),
      appUser: Symbol.for('user.service.appUser'),
      manageUserOrCompanyAddress: Symbol.for('user.service.manageUserOrCompanyAddress'),
      getUserAddresses: Symbol.for('user.service.getUserAddresses'),
      cache: Symbol.for('user.service.cache'),
    },
    validator: {
      user: Symbol.for('user.validator.user'),
    },
  },
  vendor: {
    repository: {
      vendor: Symbol.for('vendor.repository.vendor'),
    },
  },
  webhook: {
    repository: {
      config: Symbol.for('webhook.repository.config'),
      delivery: Symbol.for('webhook.repository.delivery'),
    },
  },

  workOrder: {
    repository: {
      workOrder: Symbol.for('workOrder.repository.workOrder'),
      workOrderItem: Symbol.for('workOrder.repository.workOrderItem'),
      workOrderTask: Symbol.for('workOrder.repository.workOrderTask'),
      workOrderRemarksActivity: Symbol.for('workOrder.repository.workOrderRemarksActivity'),
    },
    service: {
      updateItemStatusByTasks: Symbol.for('workOrder.service.updateItemStatusByTasks'),
      updateWorkOrderStatusByTasks: Symbol.for('workOrder.service.updateWorkOrderStatusByTasks'),
      stateTransition: Symbol.for('workOrder.service.stateTransition'),
    },
  },

  mongodbConnection: Symbol.for('core.mongodbConnection'),
  expressApp: Symbol.for('core.expressApp'),

  //repository -- REMOVE THIS

  timezoneRepository: Symbol.for('core.timezoneRepository'),

  //reports and factory
  pdfReportFactory: Symbol.for('report.factory.pdf'),
  pdfReport: Symbol.for('report.pdf'),
  htmlReportFactory: Symbol.for('report.factory.html'),
  htmlReport: Symbol.for('report.html'),
  csvReportFactory: Symbol.for('report.factory.csv'),
  csvReport: Symbol.for('report.csv'),
  pivotReportFactory: Symbol.for('report.factory.pivot'),
  pivotReport: Symbol.for('report.pivot'),

  //config variable
  config: {
    appConfig: Symbol.for('config.app'),
    cloudinaryConfig: Symbol.for('config.cloudinary'),
    flexMonsterConfig: Symbol.for('config.flexMonster'),
    googleConfig: Symbol.for('config.google'),
    jsReportConfig: Symbol.for('config.jsReport'),
    mailgunConfig: Symbol.for('config.mailgun'),
    stripeConfig: Symbol.for('config.stripe'),
    zendeskConfig: Symbol.for('config.zendesk'),
    ghostConfig: Symbol.for('config.ghost'),
    quickbooksConfig: Symbol.for('config.quickbooks'),
    shipEngineConfig: Symbol.for('config.shipEngine'),
    s3Config: Symbol.for('config.s3'),
    timezoneDbConfig: Symbol.for('config.timezoneDb'),
    vonageConfig: Symbol.for('config.vonage'),
    winstonLoggerConfig: Symbol.for('config.winstonLogger'),
    textBeeConfig: Symbol.for('config.textBee'),
    simConfig: Symbol.for('config.sim'),
    bullConfig: Symbol.for('config.bull'),
    imgProxyConfig: Symbol.for('config.imgProxy'),
    openAiConfig: Symbol.for('config.openAi'),
  },

  ai: {
    service: Symbol.for('ai.service.ai'),
    tool: {
      factory: Symbol.for('ai.tool.factory'),
      tool: Symbol.for('ai.tool.tool'),
      functions: {
        //this needs to be string, to be used as key in tool configuration of openai
        runQuery: 'runQuery',
      },
    },
  },
}
